import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import LandingPageHeader from "../components/LandingPageHeader";
import LandingPageFooter from "../components/LandingPageFooter";

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function PaymentWaiting() {
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const transactionId = searchParams.get('transactionId');

    if (!transactionId) {
      navigate('/pre-book');
      return;
    }

    const checkStatus = async () => {
      try {
        const response = await axios.get(`${API_URL}/check-transaction-status/${transactionId}`);
        
        if (response.data.status === 'SUCCESS') {
          navigate(`/success?transactionId=${transactionId}`);
        } else if (response.data.status === 'FAILURE') {
          navigate('/failure');
        }
      } catch (error) {
        console.error('Error checking status:', error);
      }
    };

    const interval = setInterval(checkStatus, 3000); // Check every 3 seconds
    
    // Cleanup interval after 2 minutes or when component unmounts
    const timeout = setTimeout(() => {
      clearInterval(interval);
      setChecking(false);
    }, 120000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [location.search, navigate]);

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-yellow-100 to-yellow-300">
      <LandingPageHeader />
      <main className="flex-grow flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8">
          <div className="text-center">
            <div className="mx-auto mb-4">
              {checking ? (
                <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-purple-500 mx-auto"></div>
              ) : (
                <svg className="w-16 h-16 text-yellow-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              )}
                         </div>
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              {checking ? "Checking Payment Status..." : "Payment Status Unknown"}
            </h2>
            <p className="text-gray-600 mb-8">
              {checking 
                ? "Please wait while we verify your payment status."
                : "We couldn't verify your payment status. Please contact support."}
            </p>
            
            {!checking && (
              <button
                onClick={() => navigate('/pre-book')}
                className="w-full bg-purple-600 text-white rounded-md py-3 px-4 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:ring-opacity-75 transition-colors"
              >
                Return to Home
              </button>
            )}
          </div>
        </div>
      </main>
      <LandingPageFooter />
    </div>
  );
}

export default PaymentWaiting;